import { IFilterService } from 'angular';
import * as XLSX from 'xlsx';

import * as LogService from '../../core/services/logservice/log.service';
import { PaymentSearchGateway } from './paymentSearch.gateway';
import { PaymentSearchViewModel } from './paymentSearch.viewmodel';


export class PaymentSearchController {

    private paymentSearchViewModel: PaymentSearchViewModel;
    private isDataGridLoading: boolean;

    static $inject = ['$filter', 'logService', 'paymentSearch.gateway'];

    constructor(
        private $filter: IFilterService,
        private logger: LogService.ILogService,
        private paymentSearchGateway: PaymentSearchGateway
    ) {
        this.paymentSearchViewModel = new PaymentSearchViewModel();
    }


    public export(): void {
        if(!this.paymentSearchViewModel
            || !this.paymentSearchViewModel.searchResults
            || this.paymentSearchViewModel.searchResults.length <= 0
        ){
            return;
        }

        const organizationName = this.paymentSearchViewModel.paymentSearchCriteria.organizationName;
        const paymentStartDate = this.$filter('date')(this.paymentSearchViewModel.paymentSearchCriteria.eventTimeFromUtc, 'MM/dd/yy', 'UTC');
        const paymentEndDate = this.$filter('date')(this.paymentSearchViewModel.paymentSearchCriteria.eventTimeToUtc, 'MM/dd/yy', 'UTC');
        const paymentStatus = this.paymentSearchViewModel.paymentSearchCriteria.decisionTypeCode;

        const wb = XLSX.utils.book_new();
        const data: Array<Array<string>> = [
            [
                "Search Criteria"
            ],
            [
                'Organization Name',
                organizationName
            ],
            [
                'Payment Start Date',
                paymentStartDate
            ],
            [
                'Payment End Date',
                paymentEndDate
            ],
            [
                'Payment Status',
                paymentStatus
            ],
            [],
            [
                "ID",
                "ORGANIZATION",
                "BILLING #",
                "AMOUNT",
                "ACCT",
                "TYPE",
                "REQUESTED AT",
                "STATUS",
                "REASON",
                "ORIGIN"
            ],
        ];
        this.paymentSearchViewModel.searchResults.forEach(searchResult => {
            const paymentAmount: string = this.$filter('currency')(searchResult.paymentAmount);
            const requestedAt: string = this.$filter('date')(searchResult.requestedAt, 'MM/dd/yy', 'UTC');
            const row: Array<string> = [
                searchResult.paymentId.toString(),
                searchResult.organizationName,
                searchResult.billingAccountNumber,
                paymentAmount,
                searchResult.paymentAcct,
                searchResult.paymentType,
                requestedAt,
                searchResult.decisionType,
                searchResult.reasonCode,
                searchResult.requestOriginType
            ];
            data.push(row);
        });
        var ws = XLSX.utils.aoa_to_sheet(data);
        XLSX.utils.book_append_sheet(wb, ws, "Past and Pending Payments");
        XLSX.writeFile(wb, "past-and-pending-payments.xlsx");
    }

    public submit(): void {
        this.isDataGridLoading = true;

        // if searchResultsGrid is already loaded then clear it so the spinner does not spin on top of data
        if (typeof(this.paymentSearchViewModel) != "undefined") {
            if (typeof (this.paymentSearchViewModel.searchResults) != "undefined") {
                this.paymentSearchViewModel.searchResults = null;
           }
        }

        //clear policyholderids on every search because they are not bound to the view
        this.paymentSearchViewModel.paymentSearchCriteria.policyholderIds = undefined;

        const paymentSearchViewModelPromise: ng.IPromise<PaymentSearchViewModel> = this.paymentSearchGateway.loadPaymentSearchViewModel(this.paymentSearchViewModel);
        paymentSearchViewModelPromise.then((viewModel: PaymentSearchViewModel) => {
            this.logger.debug("searchViewModelPromise", viewModel);
            this.paymentSearchViewModel = viewModel;
            this.isDataGridLoading = false;
        });
    }
}